import axiosTokenInstance from 'services/api/backoffice';
import { IPB_INVOICE_LIST, IPB_INVOICE_LIST_ERROR } from '_models/redux/types';

// Action function
export const ipbInvoiceListAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`/api/backoffice/ipb/accounting/invoices`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: IPB_INVOICE_LIST,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: IPB_INVOICE_LIST_ERROR,
        payload: e || {},
      });
    }
  };
